export class AccessRoutes
{
	static Home = '/';

	//Policy
	static PolicyList = '/policy/list';
	static PolicyNew = '/policy/new';
	static PolicyCopy(id: string)
	{
		return `/policy/${id}/new`
	}
	static PolicyEdit(id: string)
	{
		return `/policy/${id}/edit`
	}
	static PolicyView(id: string)
	{
		return `/policy/${id}/view`;
	}

	//Role
	static RoleList = '/role/list';
	static RoleNew = '/role/new';
	static RoleCopy(id: string)
	{
		return `/role/${id}/new`;
	}
	static RoleEdit(id: string)
	{
		return `/role/${id}/edit`;
	}
	static RoleView(id: string)
	{
		return `/role/${id}/view`;
	}

	//Outgoing Permission
	static PermissionView(id: string)
	{
		return `/permission/${id}/view`;
	}

	//Outgoing Permission
	static OutgoingPermissionList = '/permission/outgoing/list';
	static OutgoingPermissionNew = '/permission/outgoing/new';
	static OutgoingPermissionCopy(id: string) 
	{
		return `/permission/outgoing/${id}/new`
	}
	static OutgoingPermissionEdit(id: string) 
	{
		return `/permission/outgoing/${id}/edit`
	}
	static OutgoingPermissionView(id: string)
	{
		return `/permission/outgoing/${id}/view`;
	}

	//Incomig Permission
	static IncomingPermissionList = '/permission/incoming/list';
	static IncomingPermissionView(id: string)
	{
		return `/permission/incoming/${id}/view`;
	}
}